module.exports = "/_next/static/images/42ced802071594300bea0a1807687549-piecito-mobile-no.png";